// flow weak

import React, {
    PureComponent
  }                         from 'react';
  import PropTypes          from 'prop-types';
  import {
      defaultOptions,
      checkStatus,
      parseJSON,
      getLocationOrigin
    }                     from '../../../services/fetchTools';
  import {
    AnimatedView,
    StatsTable,StatsGraph, ScoreCard,GameTypeTab
  }                         from '../../../components';
  import Card from '../../../components/card/Card'
  import styled from 'styled-components'
  import TicketStatus from '../crud/ticketStatus'
  import CallStatus from '../crud/callStatus'
  import ResponseLeads from '../responseLeads'
  import Rental from '../crud/rental'
  import CheckInOut from '../../centerportal/checkInOut'
  import SessionDetails from '../crud/viewFixtureSession'
  import PartnerTasks from '../PartnerTasks'
  import CriticalTimeSlot from '../crud/CriticalTimeSlot'
  import CriticalBatches from '../crud/CriticalBatches'
  import UnconfirmedAllocations from '../crud/UnconfirmedAllocations'
  import SessionHealth from '../../centerportal/sessionHealth';
  import VenueList from '../../centerportal/venueList';

  
  class PartnerWorkBench extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
        super(props);
        this.state = {
          venue:this.props.statsTable.revenue_per_month.requested_venue_id,
          total_calls : [],
          coming_from:'workbench',
          section:false,
          selected_tab:props.match.params.selected_tab,
          open_audio : false,
          recording : '',
          rental_task:false,
          call:false,
          leads:false,
          onChecklistsDetails:false,
          open_tickets: 0,
          missed_calls: 0,
          response_leads: 0,
          checklist:0,
          count_of_rental_activities:0,
          incomplete_sessions_count:0,
          ticket_and_lead:true,
          critical_time_slot:false,
          critical_batch:false,
          unconfirm_alloc:false,
          incomplete_session:false,
          fixture_allocation:false

        };
        // this.handleChange = this.handleChange.bind(this);
        // // this.playAudio = this.playAudio.bind(this);
        // this.handleAudioClose = this.handleAudioClose.bind(this);
        this.onRentalClick = this.onRentalClick.bind(this);
        this.onChecklistsDetails = this.onChecklistsDetails.bind(this);
        this.getChecklistDetails = this.getChecklistDetails.bind(this);
        this.onTicketLeadsClick = this.onTicketLeadsClick.bind(this);
        this.onCriticalSlotClick = this.onCriticalSlotClick.bind(this);
        this.onCriticalBatchClick = this.onCriticalBatchClick.bind(this);
        this.onUncorfirmedAllocationsClick = this.onUncorfirmedAllocationsClick.bind(this);
        this.onIncompleteSessionDetails = this.onIncompleteSessionDetails.bind(this);
        this.getIncompletsessionCount = this.getIncompletsessionCount.bind(this);
        this.onFixtureAllocationClick = this.onFixtureAllocationClick.bind(this);
      }
  
    componentWillMount() {
      const { actions: { enterPage } } = this.props;
      enterPage('PartnerWorkBench');
    }
  
    componentDidMount() {
      this.getChecklistDetails();
      // this.getIncompletsessionCount();
      const {
        actions: {
          fetchStatsTableDataIfNeeded,
          fetchScoreCardDataIfNeeded
        }
      } = this.props;

      if(!this.state.selected_tab){
        this.setState({selected_tab:'ticket_and_lead',section:true})
      }
      if(this.state.selected_tab == 'Customers' || this.state.selected_tab == 'Leads' || this.state.selected_tab == 'Tickets' || this.state.selected_tab == 'Calls' || this.state.selected_tab == 'Downloads' || this.state.selected_tab == 'Total_leads' || this.state.selected_tab == 'Demo' ){
        this.setState({section:true})
      }
      else{
        this.setState({section:false})
      }

    }
  
    componentWillUnmount() {
      const { actions: { leavePage } } = this.props;
      leavePage('PartnerWorkBench');
    }

    getIncompletsessionCount(){
      const url = `${getLocationOrigin()}/fixture/get_IncompleteSession_Count`;
      const options = {...defaultOptions};
      console.log('get details')

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
             this.setState({incomplete_sessions_count: data.incomplete_sessions_count});
             // alert("fix");
         }).catch(error => error);
    }
  
    getChecklistDetails(){
      const url = `${getLocationOrigin()}/cm/get_activities_count`;
      const options = {...defaultOptions};
      console.log('get details')

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
             this.setState({checklist: data.count_of_activities,count_of_rental_activities:data.count_of_rental_activities});
             // alert("fix");
         }).catch(error => error);
    }
  
    onRentalClick(){

      this.setState({rental_task:true,ticket_and_lead:false,openChecklists:false,critical_time_slot:false,critical_batch:false,unconfirm_alloc:false,incomplete_session:false,fixture_allocation:false})
      this.props.history.push("/work-bench/" +'rental_task' )
      this.setState({selected_tab:'rental_task',section:false})
      };
  
    onTicketLeadsClick(){
      this.setState({ticket_and_lead:true,rental_task:false,openChecklists:false,critical_time_slot:false,critical_batch:false,unconfirm_alloc:false,incomplete_session:false,fixture_allocation:false})
      this.props.history.push("/work-bench/"+'ticket_and_lead')
      this.setState({selected_tab:'ticket_and_lead',section:true})
      };
  
   
    onIncompleteSessionDetails(){
      this.setState({ticket_and_lead:false,rental_task:false,openChecklists:false,critical_time_slot:false,critical_batch:false,incomplete_session:true,unconfirm_alloc:false,fixture_allocation:false})
      this.props.history.push("/work-bench/"+'incomplete_session')
      this.setState({selected_tab:'incomplete_session',section:false})
    }

    onChecklistsDetails(){
      this.setState({openChecklists:true,rental_task:false,ticket_and_lead:false,critical_time_slot:false,critical_batch:false,unconfirm_alloc:false,incomplete_session:false,fixture_allocation:false})
      this.props.history.push("/work-bench/"+'openChecklists')
      this.setState({selected_tab:'openChecklists',section:false})
    }

    onCriticalSlotClick(){
      this.setState({critical_time_slot:true,openChecklists:false,rental_task:false,ticket_and_lead:false,critical_batch:false,unconfirm_alloc:false,incomplete_session:false,fixture_allocation:false})
      this.props.history.push("/work-bench/"+'critical_time_slot')
      this.setState({selected_tab:'critical_time_slot',section:false})
    }

    onCriticalBatchClick(){
      this.setState({critical_batch:true,critical_time_slot:false,openChecklists:false,rental_task:false,ticket_and_lead:false,unconfirm_alloc:false,incomplete_session:false,fixture_allocation:false})
      this.props.history.push("/work-bench/"+'critical_batch')
      this.setState({selected_tab:'critical_batch',section:false})
    }

    onUncorfirmedAllocationsClick(){
      this.setState({unconfirm_alloc:true,rental_task:false,ticket_and_lead:false,openChecklists:false,critical_time_slot:false,critical_batch:false,incomplete_session:false,fixture_allocation:true})
      this.props.history.push("/work-bench/"+'unconfirm_alloc')
      this.setState({selected_tab:'unconfirm_alloc',section:false})
    }

    onCriticalSlotClick(){
      this.setState({critical_time_slot:true,openChecklists:false,rental_task:false,ticket_and_lead:false,critical_batch:false,incomplete_session:false,unconfirm_alloc:false,fixture_allocation:true})
      this.props.history.push("/work-bench/"+'critical_time_slot')
      this.setState({selected_tab:'critical_time_slot',section:false})
    }

    onFixtureAllocationClick(){
      this.setState({critical_batch:false,critical_time_slot:false,openChecklists:false,rental_task:false,ticket_and_lead:false,incomplete_session:false,unconfirm_alloc:false,fixture_allocation:true})
      this.props.history.push("/work-bench/"+'fixture_allocation')
      this.setState({selected_tab:'fixture_allocation',section:false})
    }
  
  
  
    render() {
      console.log('card0.')
      console.log(this.state.selected_tab)
      console.log(this.state.section)
      const rental_style = this.state.count_of_rental_activities > 0 ? 'red' : '#4daa0b'
      const checklist_style = this.state.checklist > 0 ? 'red' : '#4daa0b'
      const leads_style = this.state.response_leads > 0 ? 'red' : '#4daa0b'
      console.log(this.state.missed_calls)
      console.log(this.state.open_tickets)
      // console.log(Card)
      const {
        statsTable,
        scoreCard
      } = this.props;
  
      const {
        actions: {
          fetchStatsTableDataIfNeeded,
          fetchScoreCardDataIfNeeded,
        }
      } = this.props;
  
      const StyledRoot = styled.div`
      padding: 0px ;
      display: flex;
      flex-direction: row;
      margin-top:5px;
      `
      const StyledContainer = styled.div`
        
        width: 100%;
        
        `
      console.log(this.state)
      
  
  
  
      return(
      <div>
        <StyledRoot className='col-md-12'>
          {(this.state.section || this.state.selected_tab == 'ticket_and_lead')?
          <StyledContainer className='col-md-3'>
            <Card
              title="Ticket & Leads"
              count="-"
              style = {leads_style}
              action={"Contact"}
              clicked= {true}
              onClick={this.onTicketLeadsClick}
            />
          </StyledContainer>
          :
          <StyledContainer className='col-md-3'>
            <Card
              title="Ticket & Leads"
              count="-"
              style = {leads_style}
              action={"Contact"}
              clicked= {false}
              onClick={this.onTicketLeadsClick}
            />
          </StyledContainer>
        }

          <StyledContainer className='col-md-3'>
            <Card
              title="Check In & Check Out"
              count="-"
              style = {checklist_style}
              action={"Call Back"}
              clicked= {this.state.selected_tab == 'openChecklists'}
              onClick={this.onChecklistsDetails}
            />
          </StyledContainer>
          <StyledContainer className='col-md-3'>
            <Card
              title=" Upcoming Sessions"
              count="-"
              style = {leads_style}
              action={"Contact"}
              clicked= {this.state.selected_tab == 'unconfirm_alloc'}
              onClick={this.onUncorfirmedAllocationsClick}
            />
          </StyledContainer>
          <StyledContainer className='col-md-3'>
            <Card
              title="Sessions Health"
              count={this.state.incomplete_sessions_count > 0 ? this.state.incomplete_sessions_count : "-"}
              style = {leads_style}
              action={"Contact"}
              clicked= {this.state.selected_tab == 'incomplete_session'}
              onClick={this.onIncompleteSessionDetails}
            />
          </StyledContainer>

          <StyledContainer className='col-md-3'>
            <Card
              title="Fixture & Allocation"
              count="-"
              style = {leads_style}
              action={"Contact"}
              clicked= {this.state.selected_tab == 'fixture_allocation'}
              onClick={this.onFixtureAllocationClick}
            />
          </StyledContainer>

        </StyledRoot>

        
        {this.state.selected_tab == 'rental_task' &&
          <div>
              <Rental props={this.props} />
          </div>
        }
        {this.state.selected_tab == 'openChecklists' &&
          <div >
            <CheckInOut />
          </div>
        }
        {(this.state.selected_tab == 'ticket_and_lead' || this.state.section == true) &&
          <div>
            <PartnerTasks props={this.props} />
          </div>
        }

        {this.state.selected_tab == 'unconfirm_alloc' &&
          <div>
            <UnconfirmedAllocations props={this.props}/>
          </div>
        }
        {this.state.selected_tab == 'incomplete_session' &&
          <div style={{'padding':"0%"}}>
              <SessionHealth />
            </div>
        }

        {
          this.state.selected_tab == 'fixture_allocation' &&
          <div>
            <VenueList coming_from={this.state.coming_from}/>
          </div>
        }
      </div>
      );
    }
  }
  
  export default PartnerWorkBench;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/partnerWorkBench/PartnerWorkBench.js